import { get } from 'router/registry';
import {
    ABOUT,
    BECOME_PICKER,
    FAQ,
    LEGAL,
    PARTNER,
    PROFILE,
    PROFILE_CUMULUS_PRODUCTS,
    PROFILE_ORDERS,
    REGION_BERN,
    REGION_ZUERICH,
    ROOT,
} from './page-names';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

const normalisePath = (item) => Object.assign({}, item, { url: normaliseTrailingSlash(item.url) });

export const headerTooltip = function() {
    return [
        get(ABOUT),
        get(BECOME_PICKER),
    ].map(normalisePath);
};

/**
 * Pre header menu items that will be shown depending on the current user model state
 * @param { boolean } isAuthenticated - boolean flag that belongs to the user model
 * @param { boolean } hasCumulus - boolean flag that belongs to the user model
 * @returns { array } list of links
 */
export const preHeader = function({ isAuthenticated, hasCumulus }) {
    const menu = [];

    if (isAuthenticated) {
        menu.push(get(PROFILE_ORDERS));
    }

    if (hasCumulus) {
        menu.push(get(PROFILE_CUMULUS_PRODUCTS));
    }

    return menu.map(normalisePath);
};

/**
 * Menu used for the side menu, it will show conditionally contents depending on some store properties
 * @param { string } currentRouteName - current route name
 * @param { boolean } isAuthenticated - boolean flag that belongs to the user model
 * @param { boolean } hasCumulus - boolean flag that belongs to the user model
 * @returns { array } list of links
 */
export const side = function({ currentRouteName, isAuthenticated, hasCumulus }) {
    switch (currentRouteName) {
        case PROFILE:
        case PROFILE_ORDERS:
        case PROFILE_CUMULUS_PRODUCTS:
            return profile();
        default:
            return [get(ROOT)].concat(preHeader({ isAuthenticated, hasCumulus }));
    }
};

export const regions = function() {
    return [
        get(REGION_ZUERICH),
        get(REGION_BERN),
    ].map(normalisePath);
};

export const profile = function() {
    return [
        get(PROFILE),
        get(PROFILE_ORDERS),
        get(PROFILE_CUMULUS_PRODUCTS),
    ].map(normalisePath);
};

export const contentPages = function() {
    return [
        get(FAQ),
        get(ABOUT),
        get(BECOME_PICKER),
    ]
        .concat(regions())
        .concat([get(PARTNER)])
        .map(normalisePath);
};

export const legalAndPrivacy = function() {
    return [
        get(LEGAL),
    ].map(normalisePath);
};

export const social = function() {
    return [
        {
            symbol: 's-facebook',
            url: 'https://www.facebook.com/Migros',
            title: 'social.facebook',
        },
        /*
        let's comment this out because never say naver...
        {
            symbol: 's-google',
            url: '#',
            title: 'social.google',
        },
        */
        {
            symbol: 's-twitter',
            url: 'https://twitter.com/migros',
            title: 'social.twitter',
        },
        {
            symbol: 's-youtube',
            url: 'https://www.youtube.com/user/MigrosTVSpots',
            title: 'social.youtube',
        },
        {
            symbol: 's-instagram',
            url: 'https://www.instagram.com/migros',
            title: 'social.instagram',
        },
    ];
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/menus.js